export default "/img_count_3.png";